/**
 * KWS (Keyword Spotting) Adapter Interface
 * 
 * Pluggable interface for wake-word detection systems.
 * Supports both hardware-based (Porcupine) and software-based (text fallback) implementations.
 */

/**
 * KWS Adapter Base Class
 * 
 * Base class for KWS implementations
 */
export class KWSAdapter {
    constructor() {
        // Base implementation
    }
}

export default KWSAdapter;
